import React, { useState } from 'react';
import {
  Container,
  Box,
  TextField,
  Button,
  Typography,
  Alert,
  Card,
  CircularProgress,
} from '@mui/material';
import { useHistory } from 'react-router-dom';
import { apiService } from '../services/api';
import LockIcon from '@mui/icons-material/Lock';

const Login = () => {
  const history = useHistory();
  const [formData, setFormData] = useState({ id: '', password: '' });
  const [alert, setAlert] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.id || !formData.password) {
      setAlert({ severity: 'error', message: '❌ Please enter ID and password' });
      return;
    }

    setLoading(true);
    try {
      const response = await apiService.login(formData.id, formData.password);

      if (response.success) {
        setAlert({ severity: 'success', message: '✅ Login successful!' });
        setTimeout(() => {
          history.push('/admin-dashboard');
        }, 1500);
      } else {
        setAlert({ severity: 'error', message: `❌ ${response.message || 'Login failed'}` });
      }
    } catch (error) {
      setAlert({ severity: 'error', message: `❌ ${error.message}` });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', py: 4 }}>
      <Box sx={{ width: '100%' }}>
        <Card elevation={3} sx={{ p: 4, borderRadius: 2 }}>
          {/* Header */}
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <LockIcon sx={{ fontSize: 50, color: '#667eea', mb: 1 }} />
            <Typography variant="h4" sx={{ fontWeight: 700, color: '#333', mb: 1 }}>
              🔐 Login
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Enter your credentials 
            </Typography>
          </Box>

          {/* Alert */}
          {alert && (
            <Alert severity={alert.severity} sx={{ mb: 3 }} onClose={() => setAlert(null)}>
              {alert.message}
            </Alert>
          )}

          {/* Form */}
          <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
            <TextField
              label="Admin ID"
              name="id"
              value={formData.id}
              onChange={handleChange}
              fullWidth
              required
              placeholder="Enter your admin ID"
              sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#667eea' },
                  '&.Mui-focused fieldset': { borderColor: '#667eea' },
                },
              }}
            />

            <TextField
              label="Password"
              name="password"
              type="password"
              value={formData.password}
              onChange={handleChange}
              fullWidth
              required
              placeholder="Enter your password"
              sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#667eea' },
                  '&.Mui-focused fieldset': { borderColor: '#667eea' },
                },
              }}
            />

            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{
                bgcolor: '#667eea',
                py: 1.5,
                fontSize: '1rem',
                fontWeight: 600,
                mt: 2,
                '&:hover': { bgcolor: '#5568d3' },
              }}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} sx={{ color: 'white' }} /> : '🔓 Login'}
            </Button>
          </Box>

          {/* Footer */}
          <Typography variant="caption" color="text.secondary" sx={{ textAlign: 'center', display: 'block', mt: 3 }}>
            © 2025 Local Properties Services. All rights reserved.
          </Typography>
        </Card>
      </Box>
    </Container>
  );
};

export default Login;